var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnarchive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.25H2.37891H1.75C0.765625 14.25 0 13.4844 0 12.5V3.75C0 2.79297 0.765625 2 1.75 2H4.94922C5.41406 2 5.85156 2.19141 6.17969 2.51953L6.91797 3.25781C7.24609 3.58594 7.68359 3.75 8.14844 3.75H11.375C12.332 3.75 13.125 4.54297 13.125 5.5V6.375H11.8125V5.5C11.8125 5.28125 11.5938 5.0625 11.375 5.0625H8.14844C7.32812 5.0625 6.5625 4.76172 5.98828 4.1875L5.25 3.44922C5.16797 3.36719 5.05859 3.3125 4.94922 3.3125H1.75C1.50391 3.3125 1.3125 3.53125 1.3125 3.75V10.9141L3.17188 7.6875C3.33594 7.41406 3.60938 7.25 3.9375 7.25H14.875C15.1758 7.25 15.4766 7.41406 15.6133 7.6875C15.7773 7.96094 15.7773 8.31641 15.6133 8.58984L12.5508 13.8398C12.3867 14.0859 12.1133 14.25 11.8125 14.25H10.5Z",
    fill: "#6162C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchive);
export default __webpack_public_path__ + "static/media/Unarchive.1d00099f80043ea84ec19d697274f5f8.svg";
export { ForwardRef as ReactComponent };